export default __webpack_public_path__ + "static/media/java.d075be03.gif";